import { render, staticRenderFns } from "./EmptyApp.vue?vue&type=template&id=fda28008&scoped=true&lang=pug&"
import script from "./EmptyApp.vue?vue&type=script&lang=js&"
export * from "./EmptyApp.vue?vue&type=script&lang=js&"
import style0 from "@templates/EmptyApp/EmptyApp.styl?vue&type=style&index=0&id=fda28008&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda28008",
  null
  
)

export default component.exports